import type { FC } from 'react'
import slug from 'slug'
import ContentBlockWrapper from '../molecules/ContentBlockWrapper'

export type SubTitleBlockProps = {
	subTitle: string
}

export const SubTitleBlock: FC<SubTitleBlockProps> = ({ subTitle }) => {
	const id = slug(subTitle)
	return (
		<ContentBlockWrapper blockTypes={['pre-header']}>
			<div className="col-span-full">
				<div className="border-b-(length:--stroke-xs) border-b-grey-20 pb-xl">
					<h2 id={id} className="text-h4 text-blue-shade-70">
						{subTitle}
					</h2>
				</div>
			</div>
		</ContentBlockWrapper>
	)
}

export default SubTitleBlock
